var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 96 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M100 896q-24.75 0-42.375-17.625T40 836V316q0-24.75 17.625-42.375T100 256h760q24.75 0 42.375 17.625T920 316v520q0 24.75-17.625 42.375T860 896H100Zm30-580h-30v520h30V316Zm60 520h580V316H190v520Zm640-520v520h30V316h-30Zm0 0h30-30Zm-700 0h-30 30Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablet);
export default __webpack_public_path__ + "static/media/tablet.f5fbfa9799baee55a0d7d78baffc1e09.svg";
export { ForwardRef as ReactComponent };